var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('B1'),_c('B2'),_c('B3'),_c('B4'),_c('B5'),(!_vm.isMobile)?_c('B6'):_vm._e(),_c('Customer',{attrs:{"title":"我们服务的大型企业客户","entitle":"Large enterprise customers we serve"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }